import * as Proxy from './Proxy';
import i18n from '../localization';

export default (function () {
    const baseUrl = "/paymentlobby/api/PaymentUI/";
    return {
        GetPaymentToken(request) {
            var url = baseUrl + "getpaymenttoken";
            return Proxy.Post(url, request);
        },
        RedirectToHostedPaymentPage(token) {
            var locale = i18n.locale === 'en' ? "" : `?lang=${i18n.locale}`;
            return Proxy.Redirect(`https://payment.int.ambitenergy.io/#/paymentui/${token}${locale}`,
                                  `https://payment.ambitenergy.com/#/paymentui/${token}${locale}`);
        },
        RedirectToPaymentMethodPage(token) {
            var locale = i18n.locale === 'en' ? "" : `?lang=${i18n.locale}`;
            return Proxy.Redirect(`https://payment.int.ambitenergy.io/#/paymentmethods/${token}${locale}`,
                                  `https://payment.ambitenergy.com/#/paymentmethods/${token}${locale}`);
        }
    };
})()